
export default {
  data() {
    return {
      modal: false,
      images: [],
      currentImage: {},
      options: [
        {
          name: 'logo',
          label: 'Logo',
          type: 'image',
          size: '400x400',
        },
      ],
      grid: [
        {
          style: 'height: 382px; width: 76%',
        },
        {
          style: 'height: 204px; width: 24%',
        },
        {
          style: 'height: 340px; width: 42%',
        },
        {
          style: 'height: 340px; width: 34%',
        },
        {
          style: 'height: 518px; width: 24%; margin-top: -177px;',
        },

        {
          style: 'height: 204px; width: 24%',
        },
        {
          style: 'height: 382px; width: 76%',
        },
        {
          style: 'height: 518px; width: 24%; margin-top: -177px;',
        },
        {
          style: 'height: 340px; width: 34%',
        },
        {
          style: 'height: 340px; width: 42%',
        },
      ],
    }
  },
  mounted() {
    let count = 0
    this.images.forEach((image) => {
      if (count < 10) {
        image.layout = this.grid[count]
        count = count + 1
      } else {
        count = 0
        image.layout = this.grid[count]
        count = count + 1
      }
    })
  },
  methods: {
    openModal(image) {
      setTimeout(() => {
        this.modal = true
        this.currentImage = image

        this.$nextTick(() => {
          const body = document.documentElement
          body.classList.add('in-modal')
        })
        document.body.style.overflowY = 'hidden'
      }, 10)
    },
    closeModal() {
      this.currentImage = {}
      this.modal = false
      this.$nextTick(() => {
        const body = document.documentElement
        body.classList.remove('in-modal')
      })
      document.body.style.overflowY = 'auto'
    },
    nextImage() {
      let index
      this.images.map((image, i) => {
        if (image.$id === this.currentImage.$id) {
          index = i
          return
        }
      })
      if (this.images.length - 1 === index) {
        index = this.images.length - this.images.length - 1
      }
      this.currentImage = this.images[index + 1]
    },
    prevImage() {
      let index
      this.images.map((image, i) => {
        if (image.$id === this.currentImage.$id) {
          index = i
          return
        }
      })
      if (index === 0) {
        index = this.images.length
      }
      this.currentImage = this.images[index - 1]
    },
  },
}
